import styled, { createGlobalStyle, css } from 'styled-components';
import { INSIGHTS_EXPLAIN_PICKER_BODY_CLASS } from './constants';
import cssTokens, { darkCssTokens } from './theme/tokens';
export const Y_SCROLL_BAR_WIDTH = 4;

const GlobalCss = css`
  ${cssTokens}
  ${darkCssTokens}

  html,
  body {
    height: 100%;
    width: 100%;
    background-color: var(--color-bg-primary);

    font-family: Inter;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
  }

  //atlaskit modal body
  .css-1j124qj {
    border-radius: 8px !important;
  }

  html[data-theme='dark'] {
    --ds-blanket: rgba(25, 22, 30, 0.7);
  }

  html[data-theme='dark'] [role='dialog'] {
    --ds-surface-overlay: var(--color-bg-primary);
    background-color: var(--color-bg-primary);
    color: var(--color-text-primary);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
  }

  .highcharts-tooltip-container {
    z-index: 9001 !important;
  }

  /* Insights "pick a value to explain" mode: the next click on a chart point or
     matrix cell is captured instead of filtering, so signal that on the things
     that can be picked. */
  body.${INSIGHTS_EXPLAIN_PICKER_BODY_CLASS} .highcharts-container,
  body.${INSIGHTS_EXPLAIN_PICKER_BODY_CLASS} .highcharts-container *,
  body.${INSIGHTS_EXPLAIN_PICKER_BODY_CLASS} .ag-center-cols-container *,
  body.${INSIGHTS_EXPLAIN_PICKER_BODY_CLASS} tr.dt-row td * {
    cursor: crosshair !important;
  }

  a {
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {
    position: absolute;
    width: ${Y_SCROLL_BAR_WIDTH}px;
    height: 9px;
    // ag-grid ignores the height.
    // See StyleOverrides ln .ag-body-horizontal-scroll
    background-color: transparent;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--color-grey-7);
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-text-disabled);
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  .ag-popup-editor {
    background-color: var(--color-bg-primary);
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid var(--color-border-secondary);
    border-radius: 8px;
    z-index: 90001 !important;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${GlobalCss}
`;

// GlobalStyle doesn't work for our SRR pattern to build the error reports
// Additionally, it has issues for rendering storybook
export const GlobalStyleForTests = styled.div`
  ${GlobalCss}
`;

export default GlobalStyle;
